(function () {
  'use strict';
  var root = document.querySelector('[data-dcol]');
  if (!root || root.__dcol) return;
  root.__dcol = true;

  var sectionId = root.getAttribute('data-section-id');
  var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
  var swatchBase = root.getAttribute('data-swatch-base') || '';
  var collectionTitle = root.getAttribute('data-collection-title') || '';
  var ratingText = root.getAttribute('data-rating') || '';
  var deliveryText = root.getAttribute('data-delivery') || '';
  var productCache = {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function handleize(s) { return String(s).toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function withSection(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId); }
  function cleanUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + (u.search || '');
  }

  /* ---------- Response cache: one request per URL, shared by count preview, apply and scroll ---------- */
  var htmlCache = {};
  var cacheKeys = [];
  function getHtml(url) {
    var key = cleanUrl(url);
    if (htmlCache[key]) return htmlCache[key];
    var p = fetch(withSection(key), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); });
    htmlCache[key] = p;
    cacheKeys.push(key);
    if (cacheKeys.length > 24) { delete htmlCache[cacheKeys.shift()]; }
    p.catch(function () { if (htmlCache[key] === p) delete htmlCache[key]; });
    return p;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function formatMoney(cents) {
    var n = (typeof cents === 'string' ? parseInt(cents, 10) : cents) || 0;
    function fmt(num, dec, th, ds) {
      var fixed = (num / 100).toFixed(dec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 && dec > 0 ? parts[0] + ds + parts[1] : parts[0];
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(n, 2, ' ', ',');
        default: return fmt(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function swatchStyle(name) {
    var fallback = handleize(String(name).split(' ').pop());
    return 'background-color:' + fallback + ';background-image:url(' + swatchBase.replace('dcolswatch', handleize(name)) + ')';
  }

  /* ---------- Cart ---------- */
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error((e && (e.description || e.message)) || 'Could not add to bag'); });
      return r.json();
    }).then(function (item) {
      var ev = new CustomEvent('denner:cart:item-added', { bubbles: true, cancelable: true, detail: { source: 'collection-quick-add', item: item } });
      var shouldOpen = document.documentElement.dispatchEvent(ev);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (shouldOpen) {
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) {
          toggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        } else if (document.getElementById('CartDrawer')) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      }
      return item;
    });
  }

  function flash(btn, text) {
    var label = btn.querySelector('span') || btn;
    var old = label.textContent;
    btn.classList.add('is-done');
    label.textContent = text;
    setTimeout(function () { btn.classList.remove('is-done'); label.textContent = old; }, 1800);
  }

  /* ---------- Results (filters / sort) ---------- */
  var results = function () { return $('[data-dcol-results]', root); };
  var loadToken = 0;

  function swapFrom(doc) {
    var next = doc.querySelector('[data-dcol-results]');
    var nextDrawer = doc.querySelector('[data-dcol-drawer]');
    if (!next) return false;
    results().innerHTML = next.innerHTML;
    var drawer = $('[data-dcol-drawer]', root);
    if (drawer && nextDrawer) drawer.innerHTML = nextDrawer.innerHTML;
    initMore();
    return true;
  }

  function load(url, push) {
    url = cleanUrl(url);
    var token = ++loadToken;
    var res = results();
    var timer = setTimeout(function () { if (token === loadToken) res.classList.add('is-loading'); }, 120);
    closeDrawer();
    return getHtml(url)
      .then(function (html) {
        if (token !== loadToken) return;
        if (!swapFrom(parse(html))) { window.location.assign(url); return; }
        if (push) window.history.pushState({ dcol: 1 }, '', url);
        var bar = $('[data-dcol-bar]', root);
        if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'start' });
      })
      .catch(function () { if (token === loadToken) window.location.assign(url); })
      .finally(function () { clearTimeout(timer); if (token === loadToken) { var r = results(); if (r) r.classList.remove('is-loading'); } });
  }

  function formUrl(form, extra) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { v = String(v).trim(); if (v) params.append(k, v); });
    if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
    var q = params.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }
  function formExtra(form) {
    var sel = $('[data-dcol-sort]', root);
    if (!form.hasAttribute('data-dcol-drawer') && sel && sel.value) return { sort_by: sel.value };
    return null;
  }

  // Live count while ticking options. The same response is reused when "Show results" is pressed,
  // so applying several filters costs one request, not two.
  var countTimer;
  function updateCount(form) {
    clearTimeout(countTimer);
    var labels = $$('[data-dcol-count-label]', form);
    labels.forEach(function (b) { b.classList.add('is-counting'); });
    countTimer = setTimeout(function () {
      var url = cleanUrl(formUrl(form, formExtra(form)));
      form.setAttribute('data-dcol-pending', url);
      getHtml(url).then(function (html) {
        if (form.getAttribute('data-dcol-pending') !== url) return;
        var c = parse(html).querySelector('[data-dcol-total]');
        if (!c) return;
        var n = parseInt(c.getAttribute('data-dcol-total'), 10) || 0;
        labels.forEach(function (b) { b.textContent = 'Show ' + n + (n === 1 ? ' style' : ' styles'); b.classList.remove('is-counting'); });
      }).catch(function () { labels.forEach(function (b) { b.classList.remove('is-counting'); }); });
    }, 150);
  }

  function closeDropdowns(except) {
    $$('[data-dcol-dd]', root).forEach(function (dd) {
      if (dd === except) return;
      var b = $('[data-dcol-dd-toggle]', dd), p = $('.dcol-dd__panel', dd);
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    });
  }

  var lastFocus = null;
  function openDrawer() {
    var d = $('[data-dcol-drawer]', root);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dcol-lock');
    var c = $('[data-dcol-drawer-close]', d);
    if (c) setTimeout(function () { c.focus(); }, 50);
  }
  function closeDrawer() {
    var d = $('[data-dcol-drawer]', root);
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dcol-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var ddBtn = t.closest('[data-dcol-dd-toggle]');
    if (ddBtn) {
      var dd = ddBtn.closest('[data-dcol-dd]');
      var panel = $('.dcol-dd__panel', dd);
      var open = ddBtn.getAttribute('aria-expanded') === 'true';
      closeDropdowns(dd);
      ddBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      if (!open) {
        panel.style.left = ''; panel.style.right = '';
        var r = panel.getBoundingClientRect();
        if (r.right > window.innerWidth - 16) { panel.style.left = 'auto'; panel.style.right = '0'; }
      }
      return;
    }
    if (t.closest('[data-dcol-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-dcol-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var link = t.closest('[data-dcol-link]');
    if (link && link.getAttribute('href')) { e.preventDefault(); closeDropdowns(); load(link.getAttribute('href'), true); return; }

    var qvb = t.closest('[data-dcol-qv]');
    if (qvb) { e.preventDefault(); openQuickView(qvb.closest('[data-dcol-card]')); return; }
    var add = t.closest('[data-dcol-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-dcol-card]');
      var vid = add.getAttribute('data-variant-id');
      if (vid) {
        add.disabled = true;
        addToCart(vid).then(function () { flash(add, 'Added'); }).catch(function () { openQuickView(card); }).finally(function () { add.disabled = false; });
        return;
      }
      var sizes = $('[data-dcol-sizes]', card);
      if (sizes) { sizes.hidden = false; var f = $('[data-dcol-size]:not(:disabled)', sizes); if (f) f.focus(); }
      else openQuickView(card);
      return;
    }
    if (t.closest('[data-dcol-sizes-close]')) { t.closest('[data-dcol-sizes]').hidden = true; return; }
    var size = t.closest('[data-dcol-size]');
    if (size) {
      e.preventDefault();
      size.classList.add('is-busy');
      var box = size.closest('[data-dcol-sizes]');
      addToCart(size.getAttribute('data-variant-id')).then(function () {
        box.hidden = true;
        var btn = $('[data-dcol-add]', size.closest('[data-dcol-card]'));
        if (btn) flash(btn, 'Added');
      }).catch(function (err) { alertInline(box, err.message); }).finally(function () { size.classList.remove('is-busy'); });
    }
  });

  // Warm the cache when the pointer rests on a filter link (Clear, chips, stock switch)
  root.addEventListener('pointerover', function (e) {
    var link = e.target.closest && e.target.closest('[data-dcol-link]');
    if (!link || link.__dcolWarm) return;
    link.__dcolWarm = setTimeout(function () { var h = link.getAttribute('href'); if (h) getHtml(h); }, 80);
  });
  root.addEventListener('pointerout', function (e) {
    var link = e.target.closest && e.target.closest('[data-dcol-link]');
    if (link && link.__dcolWarm) { clearTimeout(link.__dcolWarm); link.__dcolWarm = null; }
  });

  function alertInline(box, msg) {
    var p = box.querySelector('.dcol-card__err');
    if (!p) { p = document.createElement('div'); p.className = 'dcol-card__err'; p.style.cssText = 'font-size:12px;color:#8A2F22'; box.appendChild(p); }
    p.textContent = msg;
  }

  root.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.dcol-card__sw [data-img]');
    if (!sw) return;
    var img = $('[data-dcol-img]', sw.closest('[data-dcol-card]'));
    if (img) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-img'); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dcol-dd]')) closeDropdowns();
    if (!e.target.closest('[data-dcol-sizes]') && !e.target.closest('[data-dcol-add]')) $$('[data-dcol-sizes]', root).forEach(function (s) { s.hidden = true; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDropdowns(); closeDrawer(); closeQuickView();
    $$('[data-dcol-sizes]', root).forEach(function (s) { s.hidden = true; });
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-dcol-form]');
    if (!form) return;
    e.preventDefault();
    clearTimeout(countTimer);
    closeDropdowns();
    load(formUrl(form, formExtra(form)), true);
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-dcol-sort]')) {
      load(formUrl($('.dcol-bar__filters', root), { sort_by: t.value }), true);
      return;
    }
    var form2 = t.closest('[data-dcol-form]');
    if (form2) updateCount(form2);
  });

  window.addEventListener('popstate', function () { load(window.location.href, false); });

  /* ---------- Sticky bar offset (theme header may be sticky or fixed) ---------- */
  var topTick = false, lastTop = -1;
  function syncTop() {
    topTick = false;
    var h = document.querySelector('.site-header');
    var top = 0;
    if (h) {
      var cands = [h, h.closest('.shopify-section'), h.parentElement];
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        if (!el) continue;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') { top = Math.max(0, Math.round(el.getBoundingClientRect().bottom)); break; }
      }
    }
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--dcol-top', top + 'px'); }
  }
  function queueTop() { if (!topTick) { topTick = true; window.requestAnimationFrame(syncTop); } }
  window.addEventListener('scroll', queueTop, { passive: true });
  window.addEventListener('resize', queueTop);
  syncTop();

  /* ---------- Continuous scroll ---------- */
  var observer = null;
  var moreLoading = false;
  function loadMore() {
    var more = $('[data-dcol-more]', root);
    if (!more || moreLoading || !more.classList.contains('is-js')) return;
    var nextUrl = more.getAttribute('data-next-url');
    if (!nextUrl) return;
    moreLoading = true;
    var token = loadToken;
    var grid = $('[data-dcol-grid]', root);
    var shown = $$('[data-dcol-card]', grid).length;
    var totalEl = $('[data-dcol-total]', root);
    var total = totalEl ? totalEl.getAttribute('data-dcol-total') : '';
    var skel = document.createElement('div');
    skel.className = 'dcol-skel';
    skel.setAttribute('aria-hidden', 'true');
    skel.innerHTML = '<div></div><div></div><div></div><div></div><div></div>';
    var status = document.createElement('div');
    status.className = 'dcol-status';
    status.setAttribute('role', 'status');
    status.innerHTML = '<span class="dcol-spin" aria-hidden="true"></span>Loading more styles · ' + shown + (total ? ' of ' + total : '');
    more.appendChild(skel); more.appendChild(status);
    getHtml(nextUrl)
      .then(function (html) {
        if (token !== loadToken || !grid.isConnected) return;
        var doc = parse(html);
        var cards = doc.querySelectorAll('[data-dcol-grid] [data-dcol-card]');
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(cards, function (c) { frag.appendChild(document.importNode(c, true)); });
        grid.appendChild(frag);
        var nm = doc.querySelector('[data-dcol-more]');
        try { window.history.replaceState(window.history.state, '', cleanUrl(nextUrl)); } catch (err) {}
        if (nm && nm.getAttribute('data-next-url')) {
          more.setAttribute('data-next-url', nm.getAttribute('data-next-url'));
          var fb = $('.dcol-more__fallback', more); if (fb) fb.setAttribute('href', nm.getAttribute('data-next-url'));
          // Start fetching the batch after this one in the background
          var after = nm.getAttribute('data-next-url');
          setTimeout(function () { getHtml(after); }, 400);
        } else {
          if (observer) observer.disconnect();
          more.parentNode.removeChild(more);
        }
      })
      .catch(function () { more.classList.remove('is-js'); })
      .finally(function () {
        if (skel.parentNode) skel.parentNode.removeChild(skel);
        if (status.parentNode) status.parentNode.removeChild(status);
        moreLoading = false;
        checkMore();
      });
  }
  function checkMore() {
    var more = $('[data-dcol-more]', root);
    if (more && more.getBoundingClientRect().top < window.innerHeight + 1200) loadMore();
  }
  // 19 Oct 2026 (phone speed): the IntersectionObserver below triggers loading; the scroll listener is only a fallback
  // for browsers without it, so it no longer measures the page on every scroll frame.
  if (!('IntersectionObserver' in window)) {
    var moreTick = false;
    window.addEventListener('scroll', function () {
      if (moreTick) return;
      moreTick = true;
      window.requestAnimationFrame(function () { moreTick = false; checkMore(); });
    }, { passive: true });
  }
  function initMore() {
    if (observer) { observer.disconnect(); observer = null; }
    var more = $('[data-dcol-more]', root);
    if (!more) return;
    more.classList.add('is-js');
    // Fetch the next batch while the shopper looks at this one
    var nu = more.getAttribute('data-next-url');
    if (nu) {
      var warm = function () { getHtml(nu); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) loadMore(); }, { rootMargin: '0px 0px 1200px 0px' });
      observer.observe(more);
    }
    checkMore();
  }
  initMore();

  /* ---------- Quick view ---------- */
  var qv = null, qvState = null, qvReturn = null;

  function buildQv() {
    if (qv) return qv;
    qv = document.createElement('div');
    qv.className = 'dcol-qv';
    qv.setAttribute('aria-hidden', 'true');
    qv.innerHTML = '<button type="button" class="dcol-qv__backdrop" data-qv-close aria-label="Close quick view" tabindex="-1"></button>' +
      '<div class="dcol-qv__dialog" role="dialog" aria-modal="true" aria-label="Quick view"><div class="dcol-qv__loading">Loading…</div></div>';
    document.body.appendChild(qv);
    qv.addEventListener('click', onQvClick);
    qv.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('button:not(:disabled), a[href]', qv.querySelector('.dcol-qv__dialog'));
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    return qv;
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); });
      productCache[handle].catch(function () { delete productCache[handle]; });
    }
    return productCache[handle];
  }
  // Pre-load quick view data when the pointer rests on a card's buttons
  root.addEventListener('pointerover', function (e) {
    var b = e.target.closest && e.target.closest('[data-dcol-qv], [data-dcol-add]');
    if (!b) return;
    var card = b.closest('[data-dcol-card]');
    if (card) getProduct(card.getAttribute('data-handle'));
  });

  function openQuickView(card) {
    if (!card) return;
    var handle = card.getAttribute('data-handle');
    qvReturn = document.activeElement;
    buildQv();
    var dialog = $('.dcol-qv__dialog', qv);
    dialog.innerHTML = '<div class="dcol-qv__loading">Loading…</div>';
    qv.classList.add('is-open');
    qv.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dcol-lock');
    getProduct(handle).then(function (product) {
      setupQv(product, card);
    }).catch(function () { window.location.assign(card.getAttribute('data-url')); });
  }

  function closeQuickView() {
    if (!qv || !qv.classList.contains('is-open')) return;
    qv.classList.remove('is-open');
    qv.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dcol-lock');
    if (qvReturn && qvReturn.focus) qvReturn.focus();
  }

  function optIndex(product, words) {
    for (var i = 0; i < product.options.length; i++) {
      var o = product.options[i];
      var n = String(o && o.name ? o.name : o).toLowerCase();
      for (var j = 0; j < words.length; j++) if (n.indexOf(words[j]) > -1) return i;
    }
    return -1;
  }

  function setupQv(product, card) {
    var ci = optIndex(product, ['colour', 'color']);
    var si = optIndex(product, ['size']);
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    qvState = { product: product, ci: ci, si: si, colour: ci > -1 ? first.options[ci] : null, size: null, fibre: card.getAttribute('data-fibre') || '', imgIndex: 0 };
    renderQv();
    var close = $('.dcol-qv__close', qv);
    if (close) close.focus();
  }

  function currentVariant() {
    var s = qvState, p = s.product;
    if (s.si > -1 && !s.size) return null;
    return p.variants.filter(function (v) {
      return (s.ci < 0 || v.options[s.ci] === s.colour) && (s.si < 0 || v.options[s.si] === s.size);
    })[0] || null;
  }

  function colourImages() {
    var s = qvState, p = s.product;
    var media = (p.media || []).filter(function (m) { return m.media_type === 'image'; });
    if (!media.length) media = (p.images || []).map(function (src) { return { src: src, alt: '' }; });
    var list = media;
    if (s.colour) {
      var c = s.colour.toLowerCase();
      var byAlt = media.filter(function (m) { return (m.alt || '').toLowerCase().indexOf(c) > -1; });
      if (byAlt.length) list = byAlt;
      else {
        var v = p.variants.filter(function (x) { return x.options[s.ci] === s.colour && x.featured_image; })[0];
        if (v) {
          var fi = v.featured_image.src.split('?')[0].replace(/^https?:/, '');
          var idx = -1;
          media.forEach(function (m, i) { if (idx < 0 && String(m.src || '').split('?')[0].replace(/^https?:/, '') === fi) idx = i; });
          if (idx > 0) list = media.slice(idx).concat(media.slice(0, idx));
        }
      }
    }
    return list.map(function (m) { return m.src || (m.preview_image && m.preview_image.src) || ''; }).filter(Boolean);
  }

  function sized(src, w) { return String(src).split('?')[0] + '?width=' + w; }

  function renderQv() {
    var s = qvState, p = s.product;
    var dialog = $('.dcol-qv__dialog', qv);
    dialog.setAttribute('aria-label', 'Quick view: ' + p.title);
    var imgs = colourImages();
    if (s.imgIndex >= imgs.length) s.imgIndex = 0;
    var v = currentVariant();
    var shownV = v || p.variants.filter(function (x) { return (s.ci < 0 || x.options[s.ci] === s.colour) && x.available; })[0] || p.variants.filter(function (x) { return s.ci < 0 || x.options[s.ci] === s.colour; })[0] || p.variants[0];
    var price = shownV.price, cmp = shownV.compare_at_price;
    var pct = cmp && cmp > price ? Math.round((cmp - price) * 100 / cmp) : 0;

    var html = '<div class="dcol-qv__gallery">';
    if (imgs.length > 1) {
      html += '<div class="dcol-qv__thumbs">';
      imgs.slice(0, 8).forEach(function (src, i) {
        html += '<button type="button" class="dcol-qv__thumb' + (i === s.imgIndex ? ' is-active' : '') + '" data-qv-img="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>';
      });
      html += '</div>';
    }
    html += '<div class="dcol-qv__main">' + (pct ? '<span class="dcol-tag dcol-tag--dark dcol-qv__tag">−' + pct + '%</span>' : '') +
      (imgs[s.imgIndex] ? '<img src="' + esc(sized(imgs[s.imgIndex], 900)) + '" srcset="' + esc(sized(imgs[s.imgIndex], 600)) + ' 600w, ' + esc(sized(imgs[s.imgIndex], 900)) + ' 900w, ' + esc(sized(imgs[s.imgIndex], 1200)) + ' 1200w" sizes="(min-width: 750px) 480px, 100vw" alt="' + esc(p.title + (s.colour ? ' in ' + s.colour : '')) + '">' : '') + '</div>';
    html += '</div>';

    html += '<div class="dcol-qv__info">';
    html += '<button type="button" class="dcol-iconbtn dcol-qv__close" data-qv-close aria-label="Close quick view"><svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M3 3l12 12M15 3L3 15" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>';
    html += '<div><div class="dcol-qv__eye">' + esc(collectionTitle) + '</div><h2 class="dcol-qv__title">' + esc(p.title) + '</h2>' + (ratingText ? '<div class="dcol-qv__rating"><span class="dcol-stars" aria-hidden="true">★★★★★</span> ' + esc(ratingText) + '</div>' : '') + '</div>';
    html += '<div class="dcol-qv__price"><strong>' + esc(formatMoney(price)) + '</strong>' + (pct ? '<s>' + esc(formatMoney(cmp)) + '</s><span>' + pct + '% off</span>' : '') + '</div>';
    if (s.fibre) html += '<div class="dcol-qv__spec">' + esc(s.fibre) + '</div>';

    if (s.ci > -1) {
      var colours = [];
      p.variants.forEach(function (x) { var c = x.options[s.ci]; if (colours.indexOf(c) < 0) colours.push(c); });
      html += '<div><div class="dcol-qv__label"><span><strong>Colour</strong> — ' + esc(s.colour) + '</span><span>' + colours.length + ' colours</span></div><div class="dcol-qv__swatches">';
      colours.forEach(function (c) {
        var avail = p.variants.some(function (x) { return x.options[s.ci] === c && x.available; });
        html += '<button type="button" class="dcol-qv__swatch' + (c === s.colour ? ' is-active' : '') + (avail ? '' : ' is-out') + '" style="' + esc(swatchStyle(c)) + '" data-qv-colour="' + esc(c) + '" aria-label="' + esc(c) + (avail ? '' : ' (sold out)') + '" aria-pressed="' + (c === s.colour) + '" title="' + esc(c) + '"></button>';
      });
      html += '</div></div>';
    }

    if (s.si > -1) {
      var sizes = [];
      p.variants.forEach(function (x) { var z = x.options[s.si]; if (sizes.indexOf(z) < 0) sizes.push(z); });
      html += '<div><div class="dcol-qv__label"><span><strong>Size</strong>' + (s.size ? ' — ' + esc(s.size) : '') + '</span><a href="/pages/guide-to-sizing" target="_blank" rel="noopener">Size guide</a></div><div class="dcol-qv__sizes">';
      sizes.forEach(function (z) {
        var vv = p.variants.filter(function (x) { return x.options[s.si] === z && (s.ci < 0 || x.options[s.ci] === s.colour); })[0];
        var ok = vv && vv.available;
        html += '<button type="button" class="dcol-qv__size' + (z === s.size ? ' is-active' : '') + '" data-qv-size="' + esc(z) + '"' + (ok ? '' : ' disabled') + ' aria-pressed="' + (z === s.size) + '">' + esc(z) + '</button>';
      });
      html += '</div><div class="dcol-qv__hint">Takes your usual size</div></div>';
    }

    var canAdd = v && v.available;
    var label = canAdd ? 'Add to bag' : (s.si > -1 && !s.size ? 'Select a size' : 'Sold out');
    html += '<div class="dcol-qv__actions"><button type="button" class="dcol-qv__add" data-qv-add' + (canAdd ? '' : ' disabled') + '><span class="dcol-qv__add-l"><svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8z M9 8V6a3 3 0 016 0v2" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>' + label + '</span><span class="dcol-qv__add-r">' + esc(formatMoney(price)) + '</span></button><div class="dcol-qv__status" role="status" aria-live="polite"></div></div>';
    var detailUrl = p.url + (v ? '?variant=' + v.id : '');
    html += '<div class="dcol-qv__foot"><span>' + esc(deliveryText) + '</span><a href="' + esc(detailUrl) + '">View full details →</a></div>';
    html += '</div>';
    dialog.innerHTML = html;
  }

  function onQvClick(e) {
    var t = e.target;
    if (t.closest('[data-qv-close]')) { closeQuickView(); return; }
    var c = t.closest('[data-qv-colour]');
    if (c) {
      qvState.colour = c.getAttribute('data-qv-colour'); qvState.imgIndex = 0;
      var cv = currentVariant(); if (cv && !cv.available) qvState.size = null;
      renderQv(); var a = $('[data-qv-colour].is-active', qv); if (a) a.focus(); return;
    }
    var z = t.closest('[data-qv-size]');
    if (z) { qvState.size = z.getAttribute('data-qv-size'); renderQv(); var add = $('[data-qv-add]', qv); if (add && !add.disabled) add.focus(); return; }
    var im = t.closest('[data-qv-img]');
    if (im) { qvState.imgIndex = parseInt(im.getAttribute('data-qv-img'), 10) || 0; renderQv(); return; }
    var btn = t.closest('[data-qv-add]');
    if (btn && !btn.disabled) {
      var variant = currentVariant();
      if (!variant) return;
      var status = $('.dcol-qv__status', qv);
      btn.disabled = true;
      addToCart(variant.id).then(function () { closeQuickView(); }).catch(function (err) {
        btn.disabled = false;
        if (status) status.textContent = err.message;
      });
    }
  }
})();
